import {
  Component, ElementRef, OnInit,
  ContentChild, DoCheck, Input, Output, EventEmitter, ViewChild, IterableDiffers
} from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { TreeComponent } from 'angular-tree-component';
import { TreeviewModel } from '../../models/treeview/treeview.model';
import { TreeviewStylingModel } from '../../models/treeview/treeview-styling.model';
import { TreeviewTemplates } from '../../templates/treeview.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF TreeView Component</p>
 * <pre>
 * <code>
 * import {{'{'}} TreeviewModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} TreeviewStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-treeview<code>></code><code><</code><code>/</code>cf-treeview<code>></code>
 * </code>
 * </pre>
 */
export class CfTreeviewComponent extends CfCoreComponent implements OnInit, DoCheck {
/**
 * @hidden 
 * An array for selected items IDs. Each item ID must be string.
 */
selectedItems = [];
/**
 * @hidden 
 * Identifier for template for each item.
 */
itemTemplate;
/**
 * <pre>{{'{'}}
 *  display: boolean,            // Default: true.
 *  disable: boolean,            // Default: false.
 *  items: [],                   // Array of items to display.
 *  options:{{'{'}}
 *   idField: string,            // Key in the items array to refer to as the id of the item. Default: id.
 *   displayField: string,       // Key in the items array to refer to as the display of the item. Default: name.
 *   childrenField: string,      // Key in the items array to refer to as the id of the item. Default: children.
 *   isExpandedField: string,    // Key in the items array to refer to as the id of the item. Default: expanded.
 *   selectable: boolean,        // Whether the items are selectable or not. Default: true.
 *   allowDrag: boolean          // Whether the items are draggable or not. Default: true.
 *   animateExpand: boolean      // Enable or disable animation. Default: false.
 * {{'}'}}
 * </pre>
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 *  display: true,
 *  items: [
 *   {{'{'}}
 *    itemID: '1',
 *    displayName: 'Microsoft',
 *    isExpanded: false
 *   {{'}'}},
 *   {{'{'}}
 *    itemID: '2',
 *    isExpanded: true,
 *    displayName: 'Apple',
 *    childrenItems: [
 *     {{'{'}}
 *       itemID: '2',
 *       isExpanded: false,
 *       displayName: 'iPhone'
 *      {{'}'}}
 *    ]
 *   {{'}'}}
 *   ],
 *  options:{{'{'}}
 *   idField: 'itemID',
 *   displayField: 'displayName',
 *   childrenField: 'childrenItems',
 *   isExpandedField: 'isExpanded',
 *   selectable: true,
 *   allowDrag: false,
 *   animateExpand: false
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 */
properties: TreeviewModel;
/**
 * <p> dynamicClass: function() -> string,	// Function that returns name of the class </p>
 * <p> class: string												// Name of the css class selector </p>
 * <p> themeColor: string									// primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 * 	// Container surrounding the TreeView
 * 	container:{{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}},
 * 	// styling of the item
 * 	item:{{'{'}}
 * 		dynamicClass,
 * 		class,
 * 		themeColor
 * 	{{'}'}}
 * {{'}'}}
 * </pre>
 */
styling: TreeviewStylingModel;
/**
 * <p>Emitting event with array of selected items</p>
 */
cfSelected: EventEmitter<any> = new EventEmitter<any>();
/**
 * <p>Emitting event on move</p>
 */
onMoveNode: EventEmitter<any> = new EventEmitter<any>();
/**
 * @hidden 
 * Identifier to register TreeComponent component.
 */
tree: TreeComponent;
/**
 * @hidden 
 * Object to register element state and compute differences.
 */
differ: any;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 * @param {?} differs
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService, differs: IterableDiffers) {
    super(elementRef, templateService);
    this.differ = differs.find([]).create(null);
    this.properties = new TreeviewModel();
    this.styling = new TreeviewStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('treeview', TreeviewTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'TREEVIEW').then( sampler => {
        // console.log('TREEVIEW', this);
      });
    });
  }
/**
 * @hidden
 * @return {?}
 */
ngDoCheck() {
    if (this.properties != null && this.tree) {
      let /** @type {?} */ changes = this.differ.diff(this.properties.items);
      if (changes) {
        this.tree.treeModel.update();
      }
    }
  }
/**
 * @hidden 
 * Function called when TreeComponent emmit his events after user iteraction with it.
 * @param {?} $event
 * @return {?}
 */
onEvent($event) {
    if ($event.eventName === 'onMoveNode') {
      this.onMoveNode.emit($event);
    }
  }
/**
 * @hidden 
 * It is function for selecting tree items
 * @param {?} node  it is json item object
 * @param {?} $event  it is angular original event for angular material md-checkbox
 * @return {?}
 */
public check(node, $event) {
    // this.tree.treeModel.update();
    this.updateChildNodesCheckBox(node, $event.checked);
    this.updateParentNodesCheckBox(node.parent);
    this.updateSelectedItems();
  }
/**
 * @hidden 
 * Function to find all checked tree items.
 * @param {?} items  array of tree items
 * @return {?}
 */
public findCheckedItems(items) {
    items.forEach((item) => {
      if (item.checked) { this.selectedItems.push(item[this.properties.options.idField]); }
      if (item[this.properties.options.childrenField]) { this.findCheckedItems(item[this.properties.options.childrenField]); }
    });
  }
/**
 * @hidden 
 * Function to update array with selected items IDs.
 * @return {?}
 */
public updateSelectedItems() {
    this.selectedItems = [];
    setTimeout(() => {
      this.findCheckedItems(this.properties.items);
      this.cfSelected.emit(this.selectedItems);
    });
  }
/**
 * @hidden 
 * Function to select/unselect item by it <b>checked</b> property and same for it childrens.
 * @param {?} node  tree item object
 * @param {?} checked  item checked state
 * @return {?}
 */
public updateChildNodesCheckBox(node, checked) {
    node.data.checked = checked;
    if (node.children) {
      node.children.forEach((child) => this.updateChildNodesCheckBox(child, checked));
    }
  }
/**
 * @hidden 
 * Function to update item parents checked states
 * @param {?} node  tree item object
 * @return {?}
 */
public updateParentNodesCheckBox(node) {
    if (node && node.level > 0 && node.children) {
      let /** @type {?} */ allChildChecked = true;
      let /** @type {?} */ noChildChecked = true;
      for (let /** @type {?} */ child of node.children) {
        if (!child.data.checked) {
          allChildChecked = false;
        } else if (child.data.checked) {
          noChildChecked = false;
        }
      }
      if (allChildChecked) {
        node.data.checked = true;
        node.data.indeterminate = false;
      } else if (noChildChecked) {
        node.data.checked = false;
        node.data.indeterminate = false;
      } else {
        node.data.checked = true;
        node.data.indeterminate = true;
      }
      this.updateParentNodesCheckBox(node.parent);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-treeview',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-treeview'\"> <tree-root *ngIf=\"!itemTemplate\" #tree [nodes]=\"properties?.items\" [options]=\"properties?.options\" (onEvent)=\"onEvent($event)\" (onUpdateData)=\"onEvent($event)\"> <ng-template #treeNodeTemplate let-node let-index=\"index\"> <div class=\"{{activeTemplate.style?.item?.class}} {{styling?.item?.class}} {{getDynamicClasses(activeTemplate.style?.item?.dynamicClass)}} {{getDynamicClasses(styling?.item?.dynamicClass)}}\" [ngClass]=\"'cf-treeview-item'\"> <md-checkbox class=\"cf-treeview-item-checkbox\" *ngIf=\"properties?.options?.selectable\" md-primary (change)=\"check(node, $event)\" [(ngModel)]=\"node.data.checked\" [(checked)]=\"node.data.checked\" [(indeterminate)]=\"node.data.indeterminate\"></md-checkbox> <span class=\"cf-treeview-item-label\">{{ node?.data[nameKey] }}</span> </div> </ng-template> </tree-root> <tree-root *ngIf=\"itemTemplate\" #tree [nodes]=\"properties?.items\" [options]=\"properties?.options\" (onEvent)=\"onEvent($event)\" (onUpdateData)=\"onEvent($event)\"> <ng-template #treeNodeTemplate let-node let-index=\"index\"> <div class=\"{{activeTemplate.style?.item?.class}} {{styling?.item?.class}} {{getDynamicClasses(activeTemplate.style?.item?.dynamicClass)}} {{getDynamicClasses(styling?.item?.dynamicClass)}}\" [ngClass]=\"'cf-treeview-item'\"> <md-checkbox class=\"cf-treeview-item-checkbox\" *ngIf=\"properties?.options?.selectable\" md-primary (change)=\"check(node, $event)\" [(ngModel)]=\"node.data.checked\" [(checked)]=\"node.data.checked\" [(indeterminate)]=\"node.data.indeterminate\"></md-checkbox> <span class=\"cf-treeview-item-label\" *ngIf=\"itemTemplate\"> <span [ngTemplateOutlet]=\"itemTemplate\" [ngOutletContext]=\"{item: node?.data}\"></span> </span> </div> </ng-template> </tree-root> </div>",
  styles: ["/** *How to define a color palette in sass */ .cf-treeview /deep/ tree-viewport { overflow: visible; } .cf-treeview /deep/ tree-node-expander { display: flex; justify-content: center; align-items: center; width: 13px; height: 22px; } .cf-treeview /deep/ tree-node-collection > div > div { margin-top: 0px !important; } .cf-treeview /deep/ .toggle-children-wrapper { padding: 0px; display: flex; width: 13px; height: 13px; align-items: center; justify-content: center; } .cf-treeview /deep/ .toggle-children-wrapper .toggle-children { width: 0px; height: 0px; background: none; border-top: 5px solid transparent; border-left: 10px solid #0D47A1; border-bottom: 5px solid transparent; transition: ease 0.3s all; } .cf-tree-item { color: #009688; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
{type: IterableDiffers, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'itemTemplate': [{ type: ContentChild, args: ['itemTpl', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'cfSelected': [{ type: Output },],
'onMoveNode': [{ type: Output },],
'tree': [{ type: ViewChild, args: [TreeComponent, ] },],
};
}

function CfTreeviewComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfTreeviewComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfTreeviewComponent.ctorParameters;
/** @type {?} */
CfTreeviewComponent.propDecorators;
/**
 * @hidden 
 * An array for selected items IDs. Each item ID must be string.
 * @type {?}
 */
CfTreeviewComponent.prototype.selectedItems;
/**
 * @hidden 
 * Identifier for template for each item.
 * @type {?}
 */
CfTreeviewComponent.prototype.itemTemplate;
/**
 * <pre>{{'{'}}
 *  display: boolean,            // Default: true.
 *  disable: boolean,            // Default: false.
 *  items: [],                   // Array of items to display.
 *  options:{{'{'}}
 *   idField: string,            // Key in the items array to refer to as the id of the item. Default: id.
 *   displayField: string,       // Key in the items array to refer to as the display of the item. Default: name.
 *   childrenField: string,      // Key in the items array to refer to as the id of the item. Default: children.
 *   isExpandedField: string,    // Key in the items array to refer to as the id of the item. Default: expanded.
 *   selectable: boolean,        // Whether the items are selectable or not. Default: true.
 *   allowDrag: boolean          // Whether the items are draggable or not. Default: true.
 *   animateExpand: boolean      // Enable or disable animation. Default: false.
 * {{'}'}}
 * </pre>
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 *  display: true,
 *  items: [
 *   {{'{'}}
 *    itemID: '1',
 *    displayName: 'Microsoft',
 *    isExpanded: false
 *   {{'}'}},
 *   {{'{'}}
 *    itemID: '2',
 *    isExpanded: true,
 *    displayName: 'Apple',
 *    childrenItems: [
 *     {{'{'}}
 *       itemID: '2',
 *       isExpanded: false,
 *       displayName: 'iPhone'
 *      {{'}'}}
 *    ]
 *   {{'}'}}
 *   ],
 *  options:{{'{'}}
 *   idField: 'itemID',
 *   displayField: 'displayName',
 *   childrenField: 'childrenItems',
 *   isExpandedField: 'isExpanded',
 *   selectable: true,
 *   allowDrag: false,
 *   animateExpand: false
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfTreeviewComponent.prototype.properties;
/**
 * <p> dynamicClass: function() -> string,	// Function that returns name of the class </p>
 * <p> class: string												// Name of the css class selector </p>
 * <p> themeColor: string									// primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 * 	// Container surrounding the TreeView
 * 	container:{{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}},
 * 	// styling of the item
 * 	item:{{'{'}}
 * 		dynamicClass,
 * 		class,
 * 		themeColor
 * 	{{'}'}}
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfTreeviewComponent.prototype.styling;
/**
 * <p>Emitting event with array of selected items</p>
 * @type {?}
 */
CfTreeviewComponent.prototype.cfSelected;
/**
 * <p>Emitting event on move</p>
 * @type {?}
 */
CfTreeviewComponent.prototype.onMoveNode;
/**
 * @hidden 
 * Identifier to register TreeComponent component.
 * @type {?}
 */
CfTreeviewComponent.prototype.tree;
/**
 * @hidden 
 * Object to register element state and compute differences.
 * @type {?}
 */
CfTreeviewComponent.prototype.differ;
/**
 * @hidden
 * @type {?}
 */
CfTreeviewComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
